import React from 'react';

export const Loading = () => {
  return (
    <>
      <p>Loading...</p>
    </>
  );
};
